import React, { Suspense } from 'react'
import { ICON } from '../Utils'
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Sphere, MeshDistortMaterial } from "@react-three/drei";
import styled from "styled-components";

const Container = styled.div`
  height: 100%;
  scroll-snap-align: center;
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;
function About() {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-full bg-Firefly px-11 py-16 gap-10">
        <div className="flex flex-col justify-center">
          <h1 className="text-3xl font-bold text-white mb-4">
            Hi, my Self Ashish Bendale
          </h1>
          <p className="text-gray-200 leading-relaxed">
            I am a 2016 graduate of Master of Computer Science from Kavatri
            Bahinabai Chaudhary Uttar Maharashtra University. After working in a
            software company, I realized that students need industry-ready
            skills at the time of graduation itself. With this vision, I
            founded <strong>Technoweit</strong>.
            <br /><br />
            Technoweit focuses on practical, project-based training and real
            software development exposure. Along with training, we also build
            professional websites and applications using modern technologies.
          </p>
        </div>

        <div className="w-full  ml-auto mr-auto px-4 h-[400px] flex items-center justify-center">
          <img
            alt="..."
            src={ICON.Profile2}
            className="
      w-full
      h-96
      object-cover
      rounded-md
      shadow-lg
    "
          />
        </div>



        {/* <div className="h-[400px]">
          <Container>
            <Canvas>
              <Suspense fallback={null}>
                <OrbitControls enableZoom={false} />
                <ambientLight intensity={1} />
                <directionalLight position={[3, 2, 1]} />
                <Sphere args={[1, 100, 200]} scale={2.4}>
                  <MeshDistortMaterial
                    color="#21bbcd"
                    attach="material"
                    distort={0.5}
                    speed={2}
                  />
                </Sphere>
              </Suspense>
            </Canvas>
          </Container>
        </div> */}
      </div>
      <div>
        <div className="flex flex-wrap items-center mt-32">
          <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
            <div className="text-gray-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-gray-100">
              <i className="fas fa-user-friends text-xl"></i>
            </div>
            <h3 className="text-3xl mb-2 font-semibold leading-normal">
              About Us
            </h3>
            <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-gray-700">
              Every single day we thought that tomorrow we will start working on our
              dream, We also know
              that tomorrow never occurred. "technoweit" exactly known this
              student problem, we not just solve it but also show student
              a way to achieve there dream job in a friendly atmosphere.
              "technoweit" working in training field since last year and
              guide hundreds of students who rarely get any guidance.
            </p>
            <p className="text-lg font-light leading-relaxed mt-0 mb-4 text-gray-700">
              "technoweit" is professional mobile app and website development training provider,
              and having a goal to train students, currently working person for their education
              and economical growth. Join "technoweit" now and get one near to your  dream.
            </p>

          </div>

          <div className="w-full md:w-4/12 px-4 mr-auto ml-auto">
            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-pink-600">
              <img
                alt="..."
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1051&q=80"
                className="w-full align-middle rounded-t-lg"
              />
              <blockquote className="relative p-8 mb-4">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  className="absolute left-0 w-full block"
                  style={{
                    height: "95px",
                    top: "-94px"
                  }}
                >
                  <polygon
                    points="-30,95 583,95 583,65"
                    className="text-pink-600 fill-current"
                  ></polygon>
                </svg>
                <h4 className="text-xl font-bold text-gray-700white">
                  Top Notch Services
                </h4>
                <p className="text-md font-light mt-2 text-gray-700">
                  The Arctic Ocean freezes every winter and much of the
                  sea-ice then thaws every summer, and that process will
                  continue whatever happens.
                </p>
              </blockquote>
            </div>
          </div>

        </div>
      </div>
      <div>
        <div className="container mx-auto px-4 mb-24">
          <div className="items-center flex flex-wrap">
            <div className="w-full md:w-4/12 ml-auto mr-auto px-4">
              <img
                alt="..."
                className="max-w-full rounded-lg shadow-lg"
                src={ICON.Archerboy}
              />
            </div>
            <div className="w-full md:w-5/12 ml-auto mr-auto px-4 ">
              <div className="md:pr-12">
                <div className="text-pink-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-pink-300">
                  <i className="fas fa-rocket text-xl"></i>
                </div>
                <h3 className="text-3xl font-semibold">
                  Our Mission
                </h3>
                <p className="mt-4 text-lg leading-relaxed text-gray-600">
                  technoweit" have vision to empower students to become super specialist in the field
                  of moden day technologies. "technoweit" help the for there all over development.
                  Our organization not only guide you to become employee but also help to start
                  your career as per your choice. We just have one vision that provide quality
                  education to students at affordable price.
                </p>
                <ul className="list-none mt-6">
                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-pink-200 mr-3">
                          <i className="fas fa-fingerprint"></i>
                        </span>
                      </div>
                      <div>
                        <h4 className="text-gray-600">
                          Carefully crafted components
                        </h4>
                      </div>
                    </div>
                  </li>
                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-pink-200 mr-3">
                          <i className="fab fa-html5"></i>
                        </span>
                      </div>
                      <div>
                        <h4 className="text-gray-600">Amazing page examples</h4>
                      </div>
                    </div>
                  </li>
                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-pink-600 bg-pink-200 mr-3">
                          <i className="far fa-paper-plane"></i>
                        </span>
                      </div>
                      <div>
                        <h4 className="text-gray-600">Dynamic components</h4>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default About